import PersonIcon from "../icons/PersonIcon";

const TopCenter = ({ gameData }) => {
  if (!gameData) return null;

  return (
    <span className="flex flex-col items-center justify-center font-header font-bold text-white">
      <div className="flex items-center gap-2 rounded-b-lg bg-gray-800">
        <p className="flex items-center justify-center p-2 pl-4 text-5xl">
          {gameData.HomeTeam.short}
        </p>
        <img
          className="h-14 w-14 object-cover"
          src={gameData.HomeTeam.logo}
          alt={gameData.HomeTeam.short}
        />
        <p className="min-w-[80px] text-center font-number text-4xl">{`${gameData.scoreHome}:${gameData.scoreAway}`}</p>
        <img
          className="h-14 w-14 object-cover"
          src={gameData.AwayTeam.logo}
          alt={gameData.AwayTeam.short}
        />
        <p className="flex items-center justify-center p-2 pr-4 text-5xl">
          {gameData.AwayTeam.short}
        </p>
      </div>
      <div className="flex items-center gap-2 text-center text-xl font-light">
        <PersonIcon
          style={{ color: gameData.homeJerseyColor ?? "transparent" }}
        />
        <div className="grid grid-cols-[auto_1fr_auto] items-center gap-x-3 rounded-b-lg bg-gray-700 px-2 py-1">
          <img
            className="h-6 w-6 object-cover"
            src={gameData.Phase?.Group?.Season?.Competition?.logo}
            alt={gameData.Phase.Group.Season.Competition.nick}
          />
          <span className="text-center">
            {gameData.Phase?.Group?.Season?.Competition?.nick}
          </span>
          <span className="lowercase">{gameData.CurrentPeriod?.code}</span>
        </div>
        <PersonIcon
          style={{ color: gameData.awayJerseyColor ?? "transparent" }}
        />
      </div>
    </span>
  );
};

export default TopCenter;
